module.exports = __webpack_public_path__ + "static/img/5.fdc7e66.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/atlas/laboratory/5.png
// module id = AUOM
// module chunks = 1